/* eslint-disable */
export default {
  status: 'Status',
  acceptQueueCalls: 'Aceitar chamadas em fila',
  callQueueDisabledReason:
    'Esta configuração é gerenciada pelo administrador da empresa.',
  callQueueManagement: 'Gerenciar filas',
} as const;

// @key: @#@"status"@#@ @source: @#@"Status"@#@
// @key: @#@"acceptQueueCalls"@#@ @source: @#@"Accept call queue calls"@#@
// @key: @#@"callQueueDisabledReason"@#@ @source: @#@"This setting is managed by your company administrator."@#@
// @key: @#@"callQueueManagement"@#@ @source: @#@"Manage queues"@#@
